import { DropdownButton, MenuItem } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import AirbnbIcon from 'assets/images/icons/channels/airbnb.svg?react';
import BookingDotComIcon from 'assets/images/icons/channels/booking.svg?react';
import HostfullyIcon from 'assets/images/icons/channels/hostfully.svg?react';
import VrboIcon from 'assets/images/icons/channels/vrbo.svg?react';
import { Channel } from 'models/Channels';
import { PropertyMetadata } from 'models/Properties';

interface PricingUpdatesChannelsProps {
  pricingMetadata: PropertyMetadata['pricingMetadata'] | undefined;
}

interface ChannelPricingUpdate {
  id: Channel;
  icon: JSX.Element;
  date: Date;
}

const PricingUpdatesChannels = ({
  pricingMetadata,
}: PricingUpdatesChannelsProps) => {
  const { t } = useTranslation();
  const channelsPricingUpdates = [
    pricingMetadata?.hostfullyMostRecentUpdateDate
      ? {
          id: Channel.orbirental,
          icon: <HostfullyIcon />,
          date: pricingMetadata.hostfullyMostRecentUpdateDate,
        }
      : null,
    pricingMetadata?.airbnbMostRecentUpdateDate
      ? {
          id: Channel.airbnb,
          icon: <AirbnbIcon />,
          date: pricingMetadata.airbnbMostRecentUpdateDate,
        }
      : null,
    pricingMetadata?.bookingComMostRecentUpdateDate
      ? {
          id: Channel.booking_com,
          icon: <BookingDotComIcon />,
          date: pricingMetadata.bookingComMostRecentUpdateDate,
        }
      : null,
    pricingMetadata?.vrboMostRecentUpdateDate
      ? {
          id: Channel.homeaway,
          icon: <VrboIcon />,
          date: pricingMetadata.vrboMostRecentUpdateDate,
        }
      : null,
  ].filter((x): x is ChannelPricingUpdate => x !== null);

  if (!channelsPricingUpdates.length) {
    return null;
  }

  return (
    <DropdownButton
      bsStyle="default"
      data-testid="channels-pricing-updates"
      id="channels-pricing-updates"
      title={t('pageCalendar.standalone.pricingUpdates.lastUpdateToChannels')}
    >
      {channelsPricingUpdates.map(({ id, icon, date }) => (
        <MenuItem key={id}>
          {icon}
          {t('common.dateTimeLongWithoutWeekDay', { date })}
        </MenuItem>
      ))}
    </DropdownButton>
  );
};

export default PricingUpdatesChannels;
